import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';
import { getFiscalYears, getPeriodClosings, deleteFiscalYear } from '../services/api';
import { storeMessages } from './storeMessages';

export interface AccountingPeriod {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  isClosed: boolean;
  closedAt?: string | null;
  _count?: { journalEntries: number; periodClosings: number };
}

export interface FiscalYear {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  isClosed: boolean;
  description?: string | null;
  periods: AccountingPeriod[];
}

export type ClosingType = 'MONTHLY' | 'QUARTERLY' | 'YEARLY';

export interface PeriodClosing {
  id: string;
  periodId: string;
  type: ClosingType;
  status: string;
  notes?: string | null;
  processedByName?: string;
  totalDebits: number;
  totalCredits: number;
  startedAt: string;
  completedAt?: string | null;
  period?: { id: string; name: string; fiscalYear?: { id: string; name: string } | null } | null;
}

export const useFiscalYearStoreBase = createEntityStore<FiscalYear>({
  entityName: 'fiscalYear',
  fetchFn: (page: number) => getFiscalYears(page),
  deleteFn: deleteFiscalYear,
  toast,
  messages: storeMessages,
});

export const usePeriodClosingStoreBase = createEntityStore<PeriodClosing>({
  entityName: 'periodClosing',
  fetchFn: (page: number) => getPeriodClosings(page),
  deleteFn: async () => { throw new Error('Period closings cannot be deleted'); },
  toast,
  messages: storeMessages,
});

/** 期間起訖存 UTC（起日 00:00、迄日 23:59:59.999），顯示時用 UTC 才不會在台灣變成隔天 */
export const formatPeriodDate = (iso: string, locale: string) =>
  new Date(iso).toLocaleDateString(locale, { timeZone: 'UTC', month: 'numeric', day: 'numeric' });
export const formatPeriodFullDate = (iso: string, locale: string) =>
  new Date(iso).toLocaleDateString(locale, { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric' });
/** UTC 日期 → 表單 YYYY-MM-DD */
export const utcDateInput = (iso: string) => new Date(iso).toISOString().slice(0, 10);
